(function () {
  if (window.__pwKlaviyoSubscribeInit) {
    if (typeof window.__pwKlaviyoSubscribeScan === 'function') {
      window.__pwKlaviyoSubscribeScan();
    }
    return;
  }
  window.__pwKlaviyoSubscribeInit = true;

  var REVISION = '2024-10-15';
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';

  var subscribe = function (companyId, listId, email, source) {
    var url = ENDPOINT + '?company_id=' + encodeURIComponent(companyId);
    return fetch(url, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'Content-Type': 'application/json',
        revision: REVISION
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source || 'PlantWave MIDI Bridge',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            list: {
              data: { type: 'list', id: listId }
            }
          }
        }
      })
    });
  };

  var renderMessage = function (form, type, text) {
    form.querySelectorAll('.pwb-form__message').forEach(function (el) {
      el.remove();
    });
    var msg = document.createElement('p');
    msg.className = 'pwb-form__message pwb-form__message--' + type;
    msg.setAttribute('role', type === 'success' ? 'status' : 'alert');
    msg.textContent = text;
    form.appendChild(msg);
  };

  var bindForm = function (form) {
    if (form.__pwKlaviyoBound) return;
    form.__pwKlaviyoBound = true;

    var companyId = form.getAttribute('data-pw-klaviyo-company') || 'WPSVMn';
    var listId = form.getAttribute('data-pw-klaviyo-list') || 'YxRavi';
    var source = form.getAttribute('data-pw-klaviyo-source') || 'PlantWave MIDI Bridge';

    var emailInput = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');
    var successText = form.getAttribute('data-pw-klaviyo-success') || 'Thanks — check your inbox.';
    var errorText = form.getAttribute('data-pw-klaviyo-error') || 'Something went wrong. Please try again.';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!emailInput || !emailInput.value || !emailInput.checkValidity()) {
        emailInput && emailInput.reportValidity && emailInput.reportValidity();
        return;
      }

      if (button) button.disabled = true;
      form.setAttribute('aria-busy', 'true');

      subscribe(companyId, listId, emailInput.value, source)
        .then(function (response) {
          if (response.status === 202 || response.ok) {
            renderMessage(form, 'success', successText);
            emailInput.value = '';
            return;
          }
          return response.json().then(function (body) {
            console.warn('[Klaviyo] subscription failed', response.status, body);
            renderMessage(form, 'error', errorText);
          }, function () {
            renderMessage(form, 'error', errorText);
          });
        })
        .catch(function (err) {
          console.warn('[Klaviyo] network error', err);
          renderMessage(form, 'error', errorText);
        })
        .then(function () {
          if (button) button.disabled = false;
          form.removeAttribute('aria-busy');
        });
    });
  };

  var scan = function () {
    document.querySelectorAll('form[data-pw-klaviyo]').forEach(bindForm);
  };

  window.__pwKlaviyoSubscribeScan = scan;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.addEventListener('shopify:section:load', scan);
})();
